export const COLORS = {
  lime: { tag: '#384202', title: '#155801', text: '#384202' },
  gold: { tag: '#2b0800', title: '#ff6a00', text: '#2b0800' },
  rose: { tag: '#340014', title: '#fe2f80', text: '#340014' },
  plum: { tag: 'white', title: '#ffc9f1', text: 'white' },
  blue: { tag: 'white', title: 'white', text: 'white' },
}
